enum zeplinColor {
  Brand1 = '#4956F4',
  Brand1Hover = '#3D4AE6',
  Brand1Active = '#323ED1',
  Neutral5 = '#DEDEDE',
  Neutral8 = '#757575',
  BasicBlack = '#000000',
  ErrorHover = '#E02727',
  Error = '#F03B3B',
  Red1 = '#EE4C4C',
  BlockBG = '#F03B3B14',
  Neutral1 = '#FFFFFF',
  Neutral2 = '#FAFAFA',
  Neutral9 = '#575757',
  Neutral7 = '#A3A3A3',
  Neutral3 = '#F5F5F5',
  Neutral4 = '#EBEBEB',
  Success = '#1C9E2C',
  Neutral10 = '#3B3B3B',
  Neutral6 = '#BFBFBF',
  Neutral11 = '#1C1C1C',
  Brand2 = '#D1FC57',
  AlertInfo = '#F3A03F',
  AlertInfoLight = '#F3A03F1A',
  BrandCategory = '#0D9488',
  UniversityCategory = '#2563EB',
  ProductionCategory = '#7C3AED',
  PropertyCategory = '#D97706',
  Blue = '#0C80D4',
  Blue1 = '#BDC2FB',
  Blue2 = '#C0E2FF',
  Blue3 = '#40B6D6',
  Blue4 = '#5864F4',
  Blue5 = '#45C7EB',
  Blue6 = '#C9E8FF',
  Yellow = '#E1FD90',
  Yellow1 = '#F5CC50',
  Yellow2 = '#F3A03F',
  CalendarCard1 = '#DFF2F7',
  CalendarCard2 = '#D9D2FF',

  Green = '#A7FFF9',
  Green1 = '#4ED5CC',
  Green2 = '#1C9E2C',
  Green3 = '#30CB43',
  Green4 = '#21CD36',
  Green5 = '#B5FFBE',

  USER_PROFILE_COLOR1 = '#2BDF89',
  USER_PROFILE_COLOR2 = '#51EBE1',

  USER_PROFILE_COLOR3 = '#45C8EB',

  USER_PROFILE_COLOR4 = '#DD67F0',
  USER_PROFILE_COLOR5 = '#F3A03F',
  USER_PROFILE_COLOR6 = '#8F43EC',
  USER_PROFILE_COLOR7 = '#FB476E',

  HuddleMeetingInner = '#FFEBEF',
  HuddleMeetingBorder = '#FB476E',
  USER_PROFILE_COLOR8 = '#8F42EB',
  USER_PROFILE_COLOR9 = '#A3A3A3',
  USER_PROFILE_COLOR10 = '#EE9C9C',
  USER_PROFILE_COLOR11 = '#E8E34B',
  USER_PROFILE_COLOR12 = '#63AEF9',
  USER_PROFILE_COLOR13 = '#FB476E',

  Lavender = '#E2E5FF',
}

export default zeplinColor;
